module.exports = __webpack_public_path__ + "media/src/application/media/animation/road1-1ab5d9cd7471e7536495d81ff36f1f01.svg";